// File: frontend/src/hooks/useApi.js

import { useState, useCallback } from 'react';
import apiService from '../services/apiService';

export const useApi = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const execute = useCallback(async (command, requestData = {}, userId = null, requiresAuth = false) => {
    setIsLoading(true);
    setError(null);
    setData(null);

    try {
      const response = await apiService.executeCommand(command, requestData, userId, requiresAuth);
      
      if (response.success) {
        setData(response.data);
        return response;
      } else {
        const errorMessage = response.error || 'Request failed';
        setError(errorMessage);
        return response;
      }
    } catch (err) {
      const errorMessage = err.message || 'An unexpected error occurred';
      setError(errorMessage);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setIsLoading(false);
    setError(null);
    setData(null);
  }, []);

  return {
    isLoading,
    error,
    data,
    execute,
    reset
  };
};

export default useApi;
